import { NavLink } from "react-router-dom";

const NavHome = () => {
  return (
    <>
      <NavLink end to="/">
        <p>Home</p>
      </NavLink>
    </>
  );
};

export default NavHome;
